import { PurchaseBillDetailDto, PurchaseBillHeaderDto } from "src/dtos/purchaseBill/purchaseBillDto";
import { formatDate } from "src/utils/string/stringUtil";

export interface PUR2010_R01Dto {
	purchaseBillHeaderDto: PUR2010_R01HeaderDto;
	purchaseBillDetailDtoList: PUR2010_R01DetailDto[];
}

export interface PUR2010_R01HeaderDto extends PurchaseBillHeaderDto {

}

export const defaultPUR2010_R01HeaderDto: PUR2010_R01HeaderDto = {
	valueIndex: 0,
	orderIndex: 0,
	orderIndexSeq: 0,

	purchaseBillNo: '',
	compCd: '',
	compNm: '',
	purchaseDt: formatDate(new Date()),
	customCd: '',
	customNm: '',
	moneyCd: '',
	vatType: '',
	empNo: '',
	empNm: '',
	logicCenter: '',
	purchaseAmt: 0,
	vatAmt: 0,
	totalAmt: 0,
	stockInDt: formatDate(new Date()),
	telNo: '',
	faxNo: '',
	email: '',
	taxBilling: 'N',
	taxBillNo: '',
	approveFlg: 'N',
	remark: '',
	itemNm: '',
	itemSpec: '',

	inserted: false,
	isModified: false
}

// 구매실적 상세 DTO (단일 상속 방식)
export interface PUR2010_R01DetailDto extends PurchaseBillDetailDto {
	locationCd?: string;
	locationNm?: string;
}


export const defaultPUR2010_R01DetailDto: PUR2010_R01DetailDto = {
	valueIndex: 0,
	orderIndex: 0,
	orderIndexSeq: 0,

	purchaseBillNo: '',
	itemNo: '',
	itemCd: '',
	itemNm: '',
	itemSpec: '',
	locationCd: '',
	locationNm: '',
	modelNo: '',
	compCd: '',
	purchaseDt: formatDate(new Date()),
	customCd: '',
	customNm: '',
	itemSeq: 0,
	billUnit: '',
	billQty: 1,
	billPrice: 0,
	dcAmt: 0,
	billAmt: 0,
	transportItemNo: '',
	remark: '',
	inserted: false,
	isModified: false
}
